import React from 'react';
import './styles.scss';

import pageImg2 from '../../../assets/images/welcomepages/Page2/pg2.png';
import linkImg from '../../../assets/images/welcomepages/Page2/link.png';
import jobDesc from '../../../assets/images/welcomepages/Page2/job-description.png';
import creditImg from '../../../assets/images/welcomepages/Page2/credit-card.png';
import networkingImg from '../../../assets/images/welcomepages/Page2/networking.png';
import profileImg from '../../../assets/images/welcomepages/Page2/profile.png';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Button/Button';

function Page2() {
    const navigate = useNavigate();
    const goToPage3 = () => {
        navigate('/welcome/3');
    };

    return (
        <div className='page2-cont'>
            <div className="left">
                <img src={pageImg2} alt="" />
            </div>
            <div className="right">
                <h1 className='section-heading'>
                How to create a successful Aerialborne profile?
                </h1>
                {/* <h3 className='section-sub-heading'>
                    What makes a successful AerialBorne profile?
                </h3> */}
                <p className='step-heading'>
                The best profiles attract the best clients. Design a profile that captures your strengths, tells your story, and shows your exceptional work.</p>

                <ul className='list'>
                    <li className='list-item'>
                        <div className="list-icon">
                            <img src={profileImg} alt="" />
                        </div>
                        <div className="list-data">
                            <p>Take your time in creating your profile so it’s exactly as you want it to be.</p>
                        </div>
                    </li>

                    {/* <li className='list-item'>
                        <div className="list-icon">
                            <img src={linkImg} alt="" />
                        </div>
                        <div className="list-data">
                            <p>Add your profile picture, description, and professional information.</p>
                        </div>
                    </li> */}

                    <li className='list-item'>
                        <div className="list-icon">
                            <img src={jobDesc} alt="" />
                        </div>
                        <div className="list-data">
                            <p>Accurately describe your professional skills to help you get more work.</p>
                        </div>
                    </li>

                    <li className='list-item'>
                        <div className="list-icon">
                            <img src={creditImg} alt="" />
                        </div>
                        <div className="list-data">
                            <p>
                                Put a face to your name! Upload a profile picture that clearly shows your face.
                            </p>
                        </div>
                    </li>

                    <li className='list-item'>
                        <div className="list-icon">
                            <img src={networkingImg} alt="" />
                        </div>
                        <div className="list-data">
                            <p>To keep our community secure for everyone, we may ask you to verify your ID.</p>
                        </div>
                    </li>
                </ul>

                <div className="btn-container">
                    <Button
                        label={'Are you ready?'}
                        handleClick={goToPage3}
                        customStyle={{ backgroundColor: '#08742C', color: 'white', padding:"10px 60px" }}
                       
                    />
                </div>
            </div>
        </div>
    );
}

export default Page2;
